export default {
  items: [
    {
      prefMonth: 'FEB',
      prefDate: '12/2017',
      projectPart: '120',
      address: '1530 Lone Oak Road Paducah, KY 42003',
      location: 'Building 3',
      startTime: '9:30 AM',
      endTime: '11:30 PM',
      timeZone: 'EST',
      duration: '4 HR',
      onSiteContact: 'Deanne Neel',
      name: 'KY - Paducah 1'
    },
    {
      prefMonth: 'JAN',
      prefDate: '11/2017',
      projectPart: '130',
      address: '1530 Lone Oak Road Paducah, KY 42003',
      location: 'Building 3',
      startTime: '8:30 AM',
      endTime: '11:30 PM',
      timeZone: 'EST',
      duration: '4 HR',
      onSiteContact: 'Deanne Neel',
      name: 'KY - Paducah 1'
    },
    {
      prefMonth: 'MAR',
      prefDate: '09/2017',
      projectPart: '150',
      address: '1530 Lone Oak Road Paducah, KY 42003',
      location: 'Building 3',
      startTime: '8:30 AM',
      endTime: '10:30 PM',
      timeZone: 'EST',
      duration: '4 HR',
      onSiteContact: 'Deanne Neel',
      name: 'KY - Paducah 1'
    },
    {
      prefMonth: 'MAY',
      prefDate: '12/2018',
      projectPart: '200',
      address: '1530 Lone Oak Road Paducah, KY 42003',
      location: 'Building 3',
      startTime: '8:30 AM',
      endTime: '09:30 PM',
      timeZone: 'EST',
      duration: '4 HR',
      onSiteContact: 'Deanne Neel',
      name: 'KY - Paducah 1'
    }
  ],
  eventItems: [
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    },
    {
      url: '/user/submitted/1',
      footerIcons: [],
      eventName: 'Mercy Health',
      eventManager: 'Kimberly Olson'
    }
  ],
  listNewEvent: [],
  currentUser: {
    role: 'em' // 'user' || 'em' || 'am'
  }
};



// WEBPACK FOOTER //
// ./src/_data.js